module.exports = __webpack_public_path__ + "038962cf712786066559578ad9eefa19.svg";